"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilesValidator = exports.CheckFileSize = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formatters = require("../../../../helpers/formatters");
var _formFieldPropTypes = require("../../../../propTypes/formFieldPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CheckFileSize = _ref => {
  let {
    file,
    maxFileSize = 10485760
  } = _ref;
  return file.size > maxFileSize;
};
exports.CheckFileSize = CheckFileSize;
CheckFileSize.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  file: _propTypes.default.any,
  maxFileSize: _propTypes.default.number
};
const FilesValidator = _ref2 => {
  let {
    fileList,
    clearErrors,
    fieldName,
    validFiles,
    requiredMessage
  } = _ref2;
  clearErrors(fieldName);
  // Required validation
  if (fileList.length === 0) {
    return requiredMessage;
  }
  if (fileList.length >= validFiles.maxFileCount) {
    return "The maximum number of files allowed is ".concat(validFiles.maxFileCount);
  }

  // File size validation
  const largeFile = Array.from(fileList).find(file => CheckFileSize({
    file,
    maxFileSize: validFiles.maxFileSize || 10485760
  }));
  if (largeFile) {
    return "The maximum file size allowed is ".concat((0, _formatters.FormatFileSize)(validFiles.maxFileSize));
  }
  return clearErrors(fieldName);
};
exports.FilesValidator = FilesValidator;
FilesValidator.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fileList: _propTypes.default.any,
  clearErrors: _propTypes.default.func,
  fieldName: _propTypes.default.string,
  validFiles: _formFieldPropTypes.ValidFilesPropTypes,
  requiredMessage: _propTypes.default.string
};